import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { environment } from '../environments/environment';
import { MainRoutingModule } from './main/main-routing.module';
import { TotalRoutingModule } from './total/total-routing.module';
import { WordRoutingModule } from './word/word-routing.module';
import { OptionsRoutingModule } from './options/options-routing.module';
import { MovieCollectRoutingModule } from './movie-collect/movie-collect-routing.module';
import { ExampleRoutingModule } from './example/example-routing.module';
// import { ProverbRoutingModule } from './proverb/proverb-routing.module';
// import { DialectRoutingModule } from './dialect/dialect-routing.module';
import { BoardRoutingModule } from './board/board-routing.module';
import { Saseung3RoutingModule } from './saseung3/saseung3-routing.module';

import { DonationComponent } from './donation/donation.component';
import { OpenSourceComponent } from './open-source/open-source.component';
import { LegalNoticeComponent } from "./legal-notice/legal-notice.component";
import {AdminMsgComponent} from "./admin-msg/admin-msg.component";


const routes: Routes = [
  {
    path: '',
    redirectTo: 'main',
    pathMatch: 'full',
  },
  {
    path: 'main',
    loadChildren: () => import('./main/main.module').then(m => m.MainModule),
  },
  {
    path: 'dialect',
    loadChildren: () => import('./dialect/dialect.module').then(m => m.DialectModule),
  },
  {
    path: 'proverb',
    loadChildren: () => import('./proverb/proverb.module').then(m => m.ProverbModule),
  },
  {
    path: 'saseung',
    loadChildren: () => import('./saseung3/saseung3.module').then(m => m.Saseung3Module),
  },
  {
    path: 'board/:cat/:id',
    loadChildren: () => import('./board/board.module').then(m => m.BoardModule),
  },
  {
    path: 'board/:cat',
    loadChildren: () => import('./board/board.module').then(m => m.BoardModule),
  },
  {
    path: 'total',
    loadChildren: () => import('./total/total.module').then(m => m.TotalModule),
  },
  {
    path: 'link',
    loadChildren: () => import('./link/link.module').then(m => m.LinkModule),
  },
  {
    path: 'donation',
    component: DonationComponent,
  },
  {
    path: 'open-source',
    component: OpenSourceComponent,
  },
  {
    path: 'legal-notice',
    component: LegalNoticeComponent,
  },
  {
    path: 'admin-msg',
    component: AdminMsgComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: environment.useHash,
      // onSameUrlNavigation: 'reload',
    }),
    // TODO: 개별 모듈 안에도 포함하고, 여기에도 포함하면 이중으로 포함하는 것 아닌가? 한쪽만 포함히야 하지 않나?
    MainRoutingModule,
    TotalRoutingModule,
    WordRoutingModule,
    OptionsRoutingModule,
    MovieCollectRoutingModule,
    ExampleRoutingModule,
    // ProverbRoutingModule,
    // DialectRoutingModule,
    BoardRoutingModule,
    Saseung3RoutingModule,
  ],
  exports: [
    RouterModule,
  ],
})
export class AppRoutingModule { }
